import { IAction } from '@Root/types'

export const ThemeActionTypes = {
  FETCH_THEMES: '@@theme/FETCH_THEMES',
  FETCH_THEMES_SUCCESS: '@@theme/FETCH_THEMES_SUCCESS',
  FETCH_THEMES_FAILURE: '@@theme/FETCH_THEMES_FAILURE',
}

export interface IThemeState {
  readonly themes: ITheme[]
  readonly loading: boolean
  readonly hasLoadedInitially: boolean
}

export interface ITheme {
  readonly id: number
  readonly attributes: IThemeAttributes
}

export interface IThemeAttributes {
  readonly name: string
  readonly sampleUrl?: string
  readonly sampleImageUrl?: string
  readonly sampleUrlSetup?: string
  readonly sampleImageUrlSetup?: string
}

export interface IThemeData {
  readonly id: string
  readonly type: 'theme'
  readonly attributes: IThemeAttributes
}

export interface IFetchThemesSuccessResponseBody {
  readonly data: IThemeData[]
}

export type TThemeActionTypes = IAction<IFetchThemesSuccessResponseBody>
